module.exports = __webpack_public_path__ + "img/TidyUP_logo.940a5595.jpg";